const galleryMessage = [
  {
    id: 1,
    image:
      "https://res.cloudinary.com/ddx3pzjlm/image/upload/v1751594608/GM1_g0ncm0.png",
    title: "Screen1",
  },
  {
    id: 2,
    image:
      "https://res.cloudinary.com/ddx3pzjlm/image/upload/v1751594609/GM2_so2f2d.png",
    title: "Screen2",
  },
  {
    id: 3,
    image:
      "https://res.cloudinary.com/ddx3pzjlm/image/upload/v1751594610/GM3_nwbvpj.png",
    title: "Screen3",
  },
  {
    id: 4,
    image:
      "https://res.cloudinary.com/ddx3pzjlm/image/upload/v1751594610/GM4_ki6n34.png",
    title: "Screen4",
  },
  {
    id: 5,
    image:
      "https://res.cloudinary.com/ddx3pzjlm/image/upload/v1751594610/GM5_lt1dzx.png",
    title: "Screen5",
  },
  {
    id: 6,
    image:
      "https://res.cloudinary.com/ddx3pzjlm/image/upload/v1751594610/GM6_orqpen.png",
    title: "Screen6",
  },
  {
    id: 7,
    image:
      "https://res.cloudinary.com/ddx3pzjlm/image/upload/v1751594611/GM7_gjytcs.png",
    title: "Screen7",
  },
  {
    id: 8,
    image:
      "https://res.cloudinary.com/ddx3pzjlm/image/upload/v1751594611/GM8_slymrn.png",
    title: "Screen8",
  },
  {
    id: 9,
    image:
      "https://res.cloudinary.com/ddx3pzjlm/image/upload/v1751594611/GM9_lfs6jr.png",
    title: "Screen9",
  },
  {
    id: 10,
    image:
      "https://res.cloudinary.com/ddx3pzjlm/image/upload/v1751594611/GM10_ipsvhq.png",
    title: "Screen10",
  },
  {
    id: 11,
    image:
      "https://res.cloudinary.com/ddx3pzjlm/image/upload/v1752286674/GM11_ecdien.png",
    title: "Screen11",
  },
];
export default galleryMessage;
